import { render, staticRenderFns } from "./loginBInd.vue?vue&type=template&id=f9f41b98&scoped=true&"
import script from "./loginBInd.vue?vue&type=script&lang=js&"
export * from "./loginBInd.vue?vue&type=script&lang=js&"
import style0 from "./loginBInd.vue?vue&type=style&index=0&id=f9f41b98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f41b98",
  null
  
)

export default component.exports